import m from "mithril";

import { GridModel } from "gridModel";

let GridViews = {
    parentView: {
        oninit: (vnode) => {
            GridModel.init(vnode);
        },

        onbeforeupdate: (vnode) => {
            let params = m.route.param();

            GridModel.vars.viewState = params.viewState;
            GridModel.setBodyScroll();
        },

        view: (vnode) => {
            if (!GridModel.vars.data) return;

            return m("div.white", [
                m(GridViews.viewNav),
                m(GridViews.viewSwitchForm),
                m(
                    "div.artists__bg",
                    {
                        class: GridModel.vars.viewState > 1 ? "is-active" : "",
                    },
                    [
                        m(
                            "div.artists.artists--grid.z-1",
                            {
                                class:
                                    GridModel.vars.viewType == "grid"
                                        ? "is-active"
                                        : "",
                                "data-zoom":
                                    GridModel.vars.viewState == 3
                                        ? "in"
                                        : "out",
                                "data-zoom-id": GridModel.vars.catId,
                                onscroll: (vnode) => {
                                    GridModel.setLocalStorage(
                                        GridModel.vars
                                            .localStorageGridScrollPosName,
                                        vnode.target.scrollTop || 0
                                    );
                                },
                                oncreate: (vnode) => {
                                    if (GridModel.vars.viewState == 3) {
                                        vnode.dom.scrollTop =
                                            GridModel.getLocalStorage(
                                                GridModel.vars
                                                    .localStorageGridScrollPosName
                                            ) || 0;
                                    }
                                },
                                onupdate: (vnode) => {
                                    if (GridModel.vars.viewState == 2) {
                                        vnode.dom.scrollTop = 0;
                                    }
                                },
                            },
                            m("div.artists__wrapper", m(GridViews.gridView))
                        ),
                        m(
                            "div.artists.artists--list.z-1",
                            {
                                class:
                                    GridModel.vars.viewType == "grid"
                                        ? ""
                                        : "is-active",
                                onscroll: (vnode) => {
                                    GridModel.setLocalStorage(
                                        GridModel.vars
                                            .localStorageGridScrollPosName,
                                        vnode.target.scrollTop || 0
                                    );
                                },
                                oncreate: (vnode) => {
                                    if (GridModel.vars.viewState == 3) {
                                        vnode.dom.scrollTop =
                                            GridModel.getLocalStorage(
                                                GridModel.vars
                                                    .localStorageGridScrollPosName
                                            ) || 0;
                                    }
                                },
                                onupdate: (vnode) => {
                                    if (GridModel.vars.viewState == 2) {
                                        vnode.dom.scrollTop = 0;
                                    }
                                },
                            },
                            m("div.artists__wrapper", m(GridViews.listView))
                        ),
                    ]
                ),
            ]);
        },
    },

    gridView: {
        view: (node) => {
            let gridItems = GridModel.vars.data.artists[GridModel.vars.catId],
                gridItemsDivided = GridModel.splitIntoSubArray(
                    gridItems,
                    GridModel.vars.gridDividerCount
                );

            return gridItemsDivided.map((gridItemsData, i) => {
                if (GridModel.vars.catId > 3) return;
                return m("div.artists__grid", [
                    gridItemsData.map((data, i) => {
                        let imgFormat;

                        return m(
                            "a.artists__item.no-hover.hide-child.relative.db",
                            {
                                href: data.link,
                                oncreate: (vnode) => {
                                    // console.log(
                                    //     vnode.dom.offsetWidth,
                                    //     vnode.dom.offsetHeight,
                                    //     data.imgs
                                    // );
                                    let imgFormat =
                                            vnode.dom.offsetWidth >
                                            vnode.dom.offsetHeight
                                                ? "landscape"
                                                : "portrait",
                                        imgChild =
                                            vnode.dom.querySelector("img");
                                    vnode.dom.imgFormat = imgFormat;
                                    GridModel.setImageFormatDataSrc(
                                        imgChild,
                                        data
                                    );
                                    imgChild.setAttribute(
                                        "data-format",
                                        imgFormat
                                    );
                                    imgChild.setAttribute(
                                        "data-categoryid",
                                        GridModel.vars.catId
                                    );
                                },
                                onupdate: (vnode) => {
                                    let imgChild =
                                        vnode.dom.querySelector("img");

                                    if (
                                        imgChild.getAttribute(
                                            "data-categoryid"
                                        ) == GridModel.vars.catId
                                    ) {
                                        return;
                                    }

                                    GridModel.setImageFormatDataSrc(
                                        imgChild,
                                        data
                                    );

                                    imgChild.setAttribute(
                                        "data-categoryid",
                                        GridModel.vars.catId
                                    );

                                    // does it really work to reinit lazyload? maybe yes
                                    setTimeout(() => {
                                        imgChild.classList.add("lazyload");
                                        imgChild.classList.remove("lazyloaded");
                                    }, 10);

                                    // if (imgChild.hasAttribute("src")) {
                                    //     imgChild.setAttribute("src", imgSrc);
                                    // }
                                },
                            },
                            [
                                m(
                                    "img.lazyload.lazyload__fadein.w-100.h-100.img-cover." +
                                        GridModel.vars.lazyloadClassnameArtists,
                                    {
                                        alt: data.artist.pagetitle,
                                        onupdate: (vnode) => {
                                            if (GridModel.vars.viewState == 2) {
                                                let el = vnode.dom;
                                                //el.classList.add( 'dn' );
                                                setTimeout(() => {
                                                    vnode.dom.classList.remove(
                                                        "dn"
                                                    );
                                                    //vnode.dom.classList.add( 'fadein' );
                                                }, 500);
                                            }
                                        },
                                    }
                                ),

                                m(
                                    "span.child.absolute.top-0.left-0.right-0.bottom-0.flex.justify-center.items-center.tc.bg-black-50.bg-black-50",
                                    data.artist.pagetitle
                                ),
                            ]
                        );
                    }),
                ]);
            });
        },
    },

    listView: {
        view: (vnode) => {
            let gridItems = GridModel.vars.data.artists[GridModel.vars.catId];

            return m(
                "div.container",

                gridItems.map((data, i) => {
                    return m("div.pt2.bb", [
                        m(
                            "a.artistslist-height.invert-hover.flex.justify-between.items-end",
                            {
                                href: data.link,
                            },
                            [
                                m(
                                    "span.db.fs-4.nowrap.lh-solid.pb3",
                                    data.artist.pagetitle
                                ),

                                m(
                                    "div.w-60",
                                    // {
                                    //     hidden: GridModel.vars.catId > 3,
                                    // },
                                    m(
                                        "div.flex.justify-end.items-end.w-100",
                                        [
                                            ...data.imgs.landscape,
                                            ...data.imgs.portrait,
                                        ]
                                            .sort(() => Math.random() - 0.5)
                                            .map((img, i) => {
                                                if (
                                                    i + 1 >
                                                    GridModel.vars
                                                        .gridItemRandomPosLimit
                                                )
                                                    return;

                                                return m(
                                                    "img.lazyload.lazyload__fadein.artistslist-height__item",
                                                    {
                                                        "data-src": img.thumb,
                                                        width: img.width,
                                                        height: img.height,
                                                    }
                                                );
                                            })
                                    )
                                ),
                            ]
                        ),
                    ]);
                })
            );
        },
    },

    viewNav: {
        view: (vnode) => {
            return [
                m(
                    "button#navopener.nav-btn.pointer.invert-hover.fixed.top-0.left-0.z-3.ma4.ma5-ns.bg-transparent.bn",
                    {
                        "data-nav-status": GridModel.vars.viewState,
                        ariaHaspopup: true,
                        ariaExpanded:
                            GridModel.vars.viewState == 2 ? true : false,
                        ariaControls: "nav",
                        "data-modal-open": true,
                        onclick: (e) => {
                            if (GridModel.vars.viewState == 1) {
                                GridModel.vars.viewState = GridModel.vars
                                    .isArtistsPage
                                    ? 3
                                    : 2;
                            } else if (GridModel.vars.viewState == 2) {
                                GridModel.vars.viewState = 1;
                            } else if (GridModel.vars.viewState == 3) {
                                GridModel.vars.viewState = 2;
                            }
                            GridModel.setBodyScroll();
                            if (GridModel.vars.viewState == 2) {
                                GridModel.vars.viewType =
                                    GridModel.vars.catId > 3 ? "list" : "grid";
                            }
                            m.route.set("/:viewState/:catId/:catName", {
                                viewState: GridModel.vars.viewState,
                                catId: GridModel.vars.catId,
                                catName: GridModel.vars.catName,
                            });
                        },
                    },
                    m("span.nav-btn__title", GridModel.getBtnLabel())
                ),
                m(
                    "a.invert-hover.fixed.top-0.right-0.z-max.ma4.ma5-ns",
                    {
                        href: "/",
                        hidden: GridModel.vars.viewState == 1 ? true : false,
                    },
                    m(
                        "figure.logo.dib.icon.ma0",
                        m(
                            "svg",
                            {
                                focusable: false,
                            },
                            m("use", {
                                href: "#logo",
                            })
                        ),
                        m("figcaption.clip", "Logo")
                    )
                ),
                m(
                    "div",
                    {
                        hidden: GridModel.vars.viewState == 2 ? false : true,
                    },
                    m(
                        "nav#nav.fixed.top-0.left-0.right-0.bottom-0.z-2.overflow-auto.flex.flex-column.pa4",
                        {
                            ariaModal: "true",
                            ariaLabeledby: "navopener",
                        },
                        m(
                            "ul.list.h-100.flex.flex-column.justify-center.fs-1.tc.mv4",
                            {
                                role: "menu",
                            },
                            [
                                GridModel.vars.data.categories.map(
                                    (data, i) => {
                                        return m(
                                            "li.mv2",
                                            {
                                                role: "menuitem",
                                            },
                                            m(
                                                "button.pointer.invert-hover.pa0.bg-transparent.bn",
                                                {
                                                    onmouseenter: (e) => {
                                                        GridModel.vars.catId =
                                                            data.id;
                                                    },
                                                    onclick: (e) => {
                                                        GridModel.vars.viewState = 3;
                                                        GridModel.vars.viewType =
                                                            data.id > 3
                                                                ? "list"
                                                                : "grid";
                                                        GridModel.vars.catId =
                                                            data.id;
                                                        GridModel.vars.catName =
                                                            data.name;
                                                        GridModel.setLocalStorage(
                                                            GridModel.vars
                                                                .localStorageGridViewTypeName,
                                                            GridModel.vars
                                                                .viewType
                                                        );
                                                        m.route.set(
                                                            "/:viewState/:catId/:catName",
                                                            {
                                                                viewState: 3,
                                                                catId: data.id,
                                                                catName:
                                                                    data.name,
                                                            }
                                                        );
                                                    },
                                                },
                                                data.name
                                            )
                                        );
                                    }
                                ),
                            ]
                        ),
                        m("div.mt-auto", m(GridViews.viewFooter))
                    )
                ),
            ];
        },
    },

    viewFooter: {
        view: (vnode) => {
            return m.trust(document.querySelector(".foot").innerHTML);
        },
    },

    viewSwitchForm: {
        view: (vnode) => {
            return m(
                "form.artists__filter.fade.fixed.z-2.tc",
                {
                    hidden:
                        GridModel.vars.viewState == 3 &&
                        GridModel.vars.catId < 4
                            ? false
                            : true,
                },
                m(
                    "div.flex.justify-center.items-center.pv2",
                    m(
                        "div",
                        m("input", {
                            type: "radio",
                            name: "artistsview",
                            id: "listview",
                            value: "list",
                            checked: GridModel.vars.viewType == "list",
                            onchange: (e) => {
                                GridModel.setLocalStorage(
                                    GridModel.vars.localStorageGridViewTypeName,
                                    "list"
                                );
                                GridModel.vars.viewType = "list";
                                GridModel.scrollToTop();
                            },
                        }),
                        m(
                            "label.pointer.ph3.pv2.br",
                            {
                                for: "listview",
                            },
                            m(
                                "svg",
                                {
                                    focusable: false,
                                },
                                m("use", {
                                    href: "#list",
                                })
                            ),
                            m("span.clip", "list")
                        )
                    ),
                    m(
                        "div",
                        m("input", {
                            type: "radio",
                            name: "artistsview",
                            id: "gridview",
                            value: "grid",
                            checked: GridModel.vars.viewType == "grid",
                            onchange: (e) => {
                                GridModel.setLocalStorage(
                                    GridModel.vars.localStorageGridViewTypeName,
                                    "grid"
                                );
                                GridModel.vars.viewType = "grid";
                                GridModel.scrollToTop();
                            },
                        }),
                        m(
                            "label.pointer.ph3.pv2",
                            {
                                for: "gridview",
                            },
                            m(
                                "svg",
                                {
                                    focusable: false,
                                },
                                m("use", {
                                    href: "#grid",
                                })
                            ),
                            m("span.clip", "grid")
                        )
                    )
                )
            );
        },
    },
};

export { GridViews };
